/** Copy for Journey & Artisan support welcome-pack page. */
export const JOURNEY_ARTISAN_SUPPORT_CONTENT = {
  brand: 'AXONALL RESERVE',
  headline: 'What to Expect from Studio Access & Journey Artisan Support',
  intro:
    'A simple overview of how access works within Reserve and how Journey Artisan support strengthens delivery behind each booking.',
  callout: {
    primary:
      'Journey Artisan support sits as a high-touch human service layer for the Reserve Members so you can provide a superior experience to your clients.',
    emphasis:
      'Axonall Journey Artisans do not engage with Reserve Members’ Clients.',
  },
  studioAccess: {
    title: 'Studio Access',
    bullets: [
      'Your access to Axonall comes through Studio, the private member space behind Reserve.',
      'Within Studio, members can search, review, and manage selected Axonall product in one connected environment.',
      'Access may include curated stays, experiences, off-market opportunities, and other differentiated travel options relevant to Reserve members.',
      'Members also benefit from evolving tools and systems designed to support clearer, faster, and more elevated execution.',
    ],
  },
  artisanSupport: {
    title: 'Journey Artisan Support for Advisors',
    bullets: [
      'Every booking is supported by Axonall’s Journey Artisan team as part of the Reserve experience.',
      'This support is intended to sit behind the scenes, helping the Reserve Members with care, coordination, service handling, changes, and more nuanced booking needs.',
      'The advisor remains at the centre of the client relationship; Journey Artisan support is provided to the advisor to strengthen the service delivery, not compete with it.',
      'In practice, this means members have both platform access and a trusted human layer when greater judgement, responsiveness, or attention is required.',
    ],
    footnote:
      'Members are free to choose or decline the Journey Artisan support as applicable to them.',
  },
}
